import React from "react";



const EmilyTestimonial = () => {
    return (
        <div className="Testimony">
            <img src="/images/image-emily.jpg" alt="Emily" />
            <section className="quotes">
                <p>We put our trust in Sunnyside and they delivered, making sure our needs were met and deadlines were always hit</p>
                <section className="name-title">
                    <span>Emily R.</span>
                    <span>Marketing Director</span>
                </section>
            </section>
        </div>
    );
}

export default EmilyTestimonial